import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/session.service';
import { AuthService } from '../services/auth.service';

/**
 * /:lang/login/:clinic and /:lang/signup/:clinic. A guest sees the branded
 * auth page. An already-authenticated visitor is sent to the clinic join page
 * (consent + attach) instead of guestGuard's generic bounce to home, keeping
 * ?invite= intact.
 */
export const clinicLoginGuard: CanActivateFn = async (route) => {
  const sessionService = inject(SessionService);
  const authService = inject(AuthService);
  const router = inject(Router);

  await authService.waitUntilReady();
  let hasBackend = !!sessionService.session?.token;
  const hasSupabase = !!authService.session$.value;
  if (hasBackend && !hasSupabase) {
    sessionService.clearPersisted();
    hasBackend = false;
  }
  if (!hasBackend && !hasSupabase) return true;

  const lang = route.params['lang'] || 'en';
  const slug = route.params['clinic'];
  const invite = route.queryParams['invite'];
  if (!hasBackend) {
    // Supabase restored, app session still rebuilding: hold on the spinner and
    // come back to the join page afterwards.
    sessionService.setRedirectUrl(
      `/${lang}/join/${slug}${invite ? `?invite=${encodeURIComponent(invite)}` : ''}`,
    );
    return router.createUrlTree([lang, 'app', 'loading']);
  }
  return router.createUrlTree([lang, 'join', slug], {
    queryParams: invite ? { invite } : {},
  });
};
